/** One-time migration from legacy MachineOS localStorage keys. */
const KEY_MIGRATIONS = [
  ['machineos_token', 'developmentexpress_token'],
  ['machineos_refresh_token', 'developmentexpress_refresh_token'],
  ['machineos_user', 'developmentexpress_user'],
  ['machineos_lang', 'developmentexpress_lang'],
  ['machineos_recon_export_history', 'developmentexpress_recon_export_history'],
  ['machineos_booking_feedback', 'developmentexpress_booking_feedback'],
  ['machineos_avatar_pending', 'developmentexpress_avatar_pending'],
];

const PREFIX_MIGRATIONS = [
  ['machineos_avatar_', 'developmentexpress_avatar_'],
];

export function migrateLegacyStorageKeys() {
  try {
    for (const [oldKey, newKey] of KEY_MIGRATIONS) {
      const value = localStorage.getItem(oldKey);
      if (value == null || localStorage.getItem(newKey) != null) continue;
      localStorage.setItem(newKey, value);
      localStorage.removeItem(oldKey);
    }

    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;
      for (const [oldPrefix, newPrefix] of PREFIX_MIGRATIONS) {
        if (!key.startsWith(oldPrefix)) continue;
        const newKey = `${newPrefix}${key.slice(oldPrefix.length)}`;
        if (localStorage.getItem(newKey) != null) break;
        const value = localStorage.getItem(key);
        if (value != null) {
          localStorage.setItem(newKey, value);
          localStorage.removeItem(key);
        }
        break;
      }
    }
  } catch (_err) {
    /* ignore private mode / quota errors */
  }
}
